import { useEffect, useState } from "react";
import TopNav from "ui/dashboard/topnav";
import TemplateList from "./components/templateList";
import "./style.scss";
import Schedule from "ui/automation/schedule";
import { Button, Input, Modal, Select, Tabs } from "antd";
import {
  createTemplate,
  deleteTemplate,
  getTemplateList,
  updateTemplate,
} from "./service";
import { showToast } from "ui/components/common";
import AlgoSelection from "./components/algoSelection";
export default function Page() {
  const [selectedTemplate, setSelectedTemplate] = useState<any>({});
  const [templateList, setTemplateList] = useState([]);
  const [schedules, setSchedules] = useState([]);
  const [templateType, setTemplateType] = useState("schedule");
  const [editType, setEditType] = useState("create");
  const [templateName, setTemplateName] = useState("");
  const [timeInterval, setTimeInterval] = useState(0);
  const [checkedAlgo, setCheckedAlgo] = useState([]);
  const [saveValid, setSaveValid] = useState(false);
  const [templateListLoading, setTemplateListLoading] = useState(false);

  function refreshTemplateList() {
    setTemplateListLoading(true);
    setTemplateList([]);
    getTemplateList(templateType)
      .then((data) => {
        if (data.status !== 200) {
          showToast(1, "Failed to fetch template list");
          return;
        } else {
          setTemplateList(data.data.data);
        }
      })
      .finally(() => setTemplateListLoading(false));
  }
  useEffect(() => {
    resetTemplate();
    setEditType("create");
    refreshTemplateList();
  }, [templateType]);
  useEffect(() => {
    if (selectedTemplate.id) {
      setEditType("edit");
      setTemplateName(selectedTemplate.name);
      setSchedules(selectedTemplate.schedules);
      setTimeInterval(selectedTemplate.checkInterval);
      setCheckedAlgo(selectedTemplate.algos);
    }
  }, [selectedTemplate]);
  async function onSaveTemplate() {
    if (checkedAlgo.length > 10) {
      showToast(1, "Selected algorithm should not exceed 10");
      return;
    }
    if (editType === "create") {
      const res = await createTemplate({
        checkInterval: timeInterval,
        schedules,
        name: templateName,
        algos: checkedAlgo,
        type: templateType,
      });
      if (res.status !== 200) {
        showToast(1, "Failed to save template");
      } else {
        showToast(0, "Template saved successfully");
        refreshTemplateList();
      }
    } else {
      const res = await updateTemplate(selectedTemplate.id, {
        checkInterval: timeInterval,
        schedules,
        name: templateName,
        algos: checkedAlgo,
        type: templateType,
      });
      if (res.status !== 200) {
        showToast(1, "Failed to update template");
      } else {
        showToast(0, "Template updated successfully");
        refreshTemplateList();
      }
    }
  }
  async function onDeleteTemplate() {
    Modal.confirm({
      title: "Do you want to delete this template?",
      content: `This template will be permanently deleted from this account.`,
      async onOk() {
        const res = await deleteTemplate(selectedTemplate.id);
        if (res.status !== 200) {
          showToast(1, "Failed to delete template");
        } else {
          showToast(0, "Template deleted successfully");
          refreshTemplateList();
        }
      },
      okText: "Delete",
      okButtonProps: {
        className: "primaryButton",
      },
      cancelButtonProps: {
        className: "primaryButton bordered",
      },
    });
  }
  useEffect(() => {
    if (!templateName) {
      setSaveValid(false);
      return;
    }
    if (templateType === "schedule") {
      if (!schedules.length) {
        setSaveValid(false);
        return;
      } else setSaveValid(true);
    }
    if (templateType === "algo") {
      if (!checkedAlgo.length) {
        setSaveValid(false);
        return;
      } else setSaveValid(true);
    }
  }, [templateName, checkedAlgo, schedules]);
  function resetTemplate() {
    setTemplateName("");
    setSchedules([]);
    setTimeInterval(0);
    setSelectedTemplate({});
    setCheckedAlgo([]);
  }
  function onAddClick() {
    resetTemplate();
    setEditType("create");
  }
  function onCheckAlgo(target, checked) {
    setCheckedAlgo((state) => {
      const match = state.find((item) => item.name === target.name);
      if (!checked) {
        return state.filter((item) => item.name !== target.name);
      } else if (!match) {
        return [...state, target];
      }
      return state;
    });
  }
  return (
    <>
      <TopNav title="Template" />
      <div
        className="vgTemplate"
        style={{
          display: "flex",
          flexDirection: "row",
          backgroundColor: "white",
          borderRadius: "24px",

          height: "100%",
          padding: "0px 24px 0px 0px",
          margin: "0px 24px 24px 0px",
          overflow: "auto",
        }}
      >
        {/* left side of page */}
        <div
          style={{
            borderRight: "1px solid rgba(225, 225, 225, 1)",
            flex: "none",
            width: "380px",
            padding: "24px 0px",
            textAlign: "center",
            position: "relative",
          }}
        >
          <Tabs
            items={[
              { key: "schedule", label: "Schedule Templates" },
              { key: "algo", label: "Algo Templates" },
            ]}
            activeKey={templateType}
            onChange={setTemplateType}
            centered={true}
            size={"large"}
          />
          <TemplateList
            templateList={templateList}
            selectedTemplate={selectedTemplate}
            onSelect={setSelectedTemplate}
            onAddClick={onAddClick}
            currentChanged={false}
            loading={templateListLoading}
          />
        </div>
        {/* right side of page */}
        <div
          style={{
            flex: "1",
            padding: "24px 0px",
            overflow: "auto",
            textAlign: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              margin: "auto",
              textAlign: "start",
              paddingLeft: "24px ",
              height: "100%",
            }}
          >
            <div style={{ flex: "none" }}>
              <Input
                value={templateName}
                onChange={(e) => setTemplateName(e.target.value)}
                placeholder="Please enter template name"
                style={{ height: "54px", borderRadius: "16px" }}
              />
            </div>
            {templateType === "schedule" && (
              <div style={{ flex: "1" }}>
                <Schedule
                  alertSchedules={schedules}
                  setAlertSchedules={setSchedules}
                />
                <div style={{ textAlign: "start", marginTop: "16px" }}>
                  Time Interval
                </div>
                <div style={{ width: "100%" }}>
                  <Select
                    style={{ width: "100%", height: "54px", marginTop: "8px" }}
                    options={[
                      { label: "No Run", value: 0 },
                      { label: "5 min", value: 5 * 60 },
                      { label: "15 mins", value: 15 * 60 },
                      { label: "30 min", value: 30 * 60 },
                      { label: "60 min", value: 60 * 60 },
                    ]}
                    value={timeInterval}
                    onChange={setTimeInterval}
                  />
                </div>
              </div>
            )}
            {templateType === "algo" && (
              <div style={{ marginTop: "20px", height: "100%", flex: "1" }}>
                <AlgoSelection
                  checkedAlgo={checkedAlgo}
                  onCheckAlgo={onCheckAlgo}
                />
              </div>
            )}
            <div style={{ marginTop: "16px", textAlign: "end", flex: "none" }}>
              {editType === "edit" && (
                <Button
                  className="primaryButton danger"
                  onClick={onDeleteTemplate}
                >
                  Delete Template
                </Button>
              )}

              <Button
                className="primaryButton"
                onClick={onSaveTemplate}
                disabled={!saveValid}
              >
                Save
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
